import type {
    CustomPlatformAssemblyConfig,
    CustomPlatformPropPlacementConfig,
    IndividualContentPlatformPlacementConfig,
} from './IndividualPlatformTypes'

export const level4CustomPlatformAssemblies: readonly CustomPlatformAssemblyConfig[] = []

export const level4CustomPlatformPropPlacements: readonly CustomPlatformPropPlacementConfig[] = [
    {
        name: 'Level4Bridge',
        platformRegion: 4,
        propAsset: 'Lvl04Bridge',
        propPosition: [-0.5, -14.35, -1845],
        propRotation: [0, 0, 0],
        propScale: 0.9,
        platformScale: 0,
        clones: 23,
        cloneSpacingZ: 56,
    },
    {
        name: 'Level4SpaceDonut01',
        platformRegion: 4,
        propAsset: 'Lvl04SpaceDonut',
        propPosition: [-10, 85, -2180],
        propRotation: [0.1, -2, 1],
        propScale: 3,
        platformScale: 0,
    },
    {
        name: 'Level4SpaceDonut02',
        platformRegion: 4,
        propAsset: 'Lvl04SpaceDonut',
        propPosition: [58, 0, -2050],
        propRotation: [0, 3, 1],
        propScale: 5.2,
        platformScale: 0,
    },
    {
        name: 'Level4SpaceDonut03',
        platformRegion: 4,
        propAsset: 'Lvl04SpaceDonut',
        propPosition: [-144, -35, -2300],
        propRotation: [1, -4, 0],
        propScale: 5,
        platformScale: 0,
    },
    {
        name: 'Level4SpaceDonut04',
        platformRegion: 4,
        propAsset: 'Lvl04SpaceDonut',
        propPosition: [50, -28, -2640],
        propRotation: [-4, -0.2, -2],
        propScale: 5,
        platformScale: 0,
    },
    {
        name: 'Level4StarA01',
        platformRegion: 4,
        propAsset: 'Lvl04StarA',
        propPosition: [60, 145, -2080],
        propRotation: [1.3, 1.6, 1.7],
        propScale: 2,
        platformScale: 0,
    },
    {
        name: 'Level4StarA02',
        platformRegion: 4,
        propAsset: 'Lvl04StarA',
        propPosition: [40, 4, -2380],
        propRotation: [0.25, -0.85, 0.15],
        propScale: 3,
        platformScale: 0,
    },
    {
        name: 'Level4StarGoalA01',
        platformRegion: 4,
        propAsset: 'Lvl04StarA',
        propPosition: [0, -3, -2675],
        propRotation: [0, -1.5, 0],
        propScale: 2,
        platformScale: 0,
    },
     {
        name: 'Level4StarGoalA02',
        platformRegion: 4,
        propAsset: 'Lvl04StarA',
        propPosition: [19, 9, -2675],
        propRotation: [0.3, -2.3, 0.2],
        propScale: 1,
        platformScale: 0,
    },
      {
        name: 'Level4StarGoalA03',
        platformRegion: 4,
        propAsset: 'Lvl04StarA',
        propPosition: [-19, 9, -2675],
        propRotation: [0.3, -0.8, 0.2],
        propScale: 1,
        platformScale: 0,
    },
    {
        name: 'Level4StarB01',
        platformRegion: 4,
        propAsset: 'Lvl04StarB',
        propPosition: [-34, 2, -2310],
        propRotation: [-0.18, 5, 0.12],
        propScale: 4,
        platformScale: 0,
    },
    {
        name: 'Level4StarB02',
        platformRegion: 4,
        propAsset: 'Lvl04StarB',
        propPosition: [-64, 118, -2740],
        propRotation: [-0.12, -0.55, -0.25],
        propScale: 5,
        platformScale: 0,
    },
    {
        name: 'Level4PirsmA01',
        platformRegion: 4,
        propAsset: 'Lvl04PirsmA',
         propPosition: [60, 35, -2820],
        propRotation: [2, -2, 1.7],
        propScale: 2,
        platformScale: 0,
    },
    {
        name: 'Level4PirsmA02',
        platformRegion: 4,
        propAsset: 'Lvl04PirsmA',
        propPosition: [92, 88, -2810],
        propRotation: [-0.2, 1.0, -0.12],
        propScale: 5.8,
        platformScale: 0,
    },
    {
        name: 'Level4PirsmB01',
        platformRegion: 4,
        propAsset: 'Lvl04PirsmB',
        propPosition: [84, 36, -2460],
        propRotation: [0.12, -0.7, 0.42],
        propScale: 4.3,
        platformScale: 0,
    },
    {
        name: 'Level4PirsmB02',
        platformRegion: 4,
        propAsset: 'Lvl04PirsmB',
        propPosition: [-96, 92, -2870],
        propRotation: [-0.28, 0.45, -0.18],
        propScale: 5.6,
        platformScale: 0,
    },
    {
        name: 'Level4SpaceHeart01',
        platformRegion: 4,
        propAsset: 'Lvl04SpaceHeart',
        propPosition: [4, 28, -2380],
        propRotation: [0, 1, 0.2],
        propScale: 1.5,
        platformScale: 0,
    },
    {
        name: 'Level4SpaceHeart02',
        platformRegion: 4,
        propAsset: 'Lvl04SpaceHeart',
        propPosition: [123, -35, -2690],
        propRotation: [-0.18, 1.4, 0.16],
        propScale: 2,
        platformScale: 0,
    },
  ] as const

export const level4IndividualContentPlatformPlacements: readonly IndividualContentPlatformPlacementConfig[] = []
